/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { mount } from 'enzyme'
import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Checkbox } from '../index'

class Container extends React.Component {
  static propTypes = {
    checked: PropTypes.bool,
    render: PropTypes.func,
  }

  static defaultProps = {
    checked: false,
  }

  state = {
    checked: this.props.checked,
  }

  handleChange = checked => {
    this.setState({
      checked,
    })
  }

  render() {
    return this.props.render({
      handleChange: this.handleChange,
      checked: this.state.checked,
    })
  }
}

describe('Checkbox', () => {
  it('Checkbox render', () => {
    const tree = mount(
      <Container
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            label="Add burger"
            id="check-0"
            onChange={handleChange}
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Checkbox render default checked', () => {
    const tree = mount(
      <Container
        checked
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            label="Add burger"
            id="check-1"
            onChange={handleChange}
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Checkbox with functional label', () => {
    const tree = mount(
      <Container
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            onChange={handleChange}
            id="check-2"
            label="Render pizza with cheddar"
            renderLabelContent={({ label }) => (
              <span>
                {label}
                🧀
              </span>
            )}
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Switcher render default checked', () => {
    const tree = mount(
      <Container
        checked
        render={({ handleChange, checked }) => (
          <Checkbox
            label="VPN"
            type="switcher"
            id="vpn"
            onChange={handleChange}
            checked={checked}
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Switcher render default unchecked, custom label', () => {
    const tree = mount(
      <Container
        render={({ handleChange, checked }) => (
          <Checkbox
            type="switcher"
            id="switch-1"
            onChange={handleChange}
            checked={checked}
            label="Functional label"
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Checkbox render default with wrong type', () => {
    const tree = mount(
      <Container
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            onChange={handleChange}
            id="wrongType"
            label="wrong type should render checkbox"
            type="wrong type"
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Checkbox disabled on', () => {
    const tree = mount(
      <Container
        checked
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            id="disabledOn"
            label="Disabled on"
            onChange={handleChange}
            disabled
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })
  it('Checkbox disabled off', () => {
    const tree = mount(
      <Container
        render={({ handleChange, checked }) => (
          <Checkbox
            checked={checked}
            id="disabledOff"
            label="Disabled off"
            onChange={handleChange}
            disabled
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })

  it('Checkbox with custom render', () => {
    const tree = mount(
      <Container
        render={({ handleChange: containerHandleChange, checked }) => (
          <Checkbox
            id="3defqt7hy"
            checked={checked}
            label="Label text"
            onChange={containerHandleChange}
            render={({ handleChange, checkboxId, renderLabelContent }) => {
              const handleClick = e => handleChange(e, !checked)

              return (
                <React.Fragment>
                  <input
                    type="radio"
                    value="on"
                    id={checkboxId}
                    name="on"
                    checked={checked}
                    onClick={handleClick}
                  />
                  <Checkbox.CheckboxLabel checkboxId={checkboxId}>
                    Label sub component{' '}
                  </Checkbox.CheckboxLabel>
                  {renderLabelContent({ label: 'LabelComponent prop' })}
                </React.Fragment>
              )
            }}
          />
        )}
      />,
    )
    expect(tree).toMatchSnapshot()
  })
})
